// src/reducers/payrollReducer.js

import { CREATE_PAYROLL, FETCH_PAYROLLS } from "../actions/constants";

const initialState = {
  payrolls: [],
  payroll: null,
};

const payrolls = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PAYROLL:
      return { ...state, payrolls: [...state.payrolls, action.payload] };
    case FETCH_PAYROLLS:
      return { ...state, payrolls: action.payload };
    default:
      return state;
  }
};

export default payrolls;
